var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tool-bar", { attrs: { title: "PT Service Logs" } }),
      _vm._v(" "),
      _vm.appReady
        ? _c(
            "v-container",
            {
              staticClass: "page-container",
              class: { "py-4": !_vm.isMobile, mobile: _vm.isMobile },
              attrs: { "grid-list-xl": "" }
            },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      class: { "pb-0": _vm.isMobile },
                      attrs: { xs12: "", sm6: "" }
                    },
                    [_c("select-students")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      class: { "pt-0": _vm.isMobile },
                      attrs: { xs12: "", sm6: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "main-action-button active",
                          attrs: { block: "" },
                          on: { click: _vm.goToSearch }
                        },
                        [
                          _c("v-icon", { staticClass: "pr-3" }, [
                            _vm._v("\n            search\n          ")
                          ]),
                          _vm._v("\n          Search Service Logs\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "mt-3 mb-5", attrs: { xs12: "" } },
                    [
                      _vm.submissionArray && _vm.submissionArray.length
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                { staticClass: "title font-bold mb-3" },
                                [
                                  _vm._v(
                                    "\n            Recent Service Logs\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-expansion-panel",
                                {
                                  staticClass: "service-log-expansion",
                                  attrs: { id: "expansion" }
                                },
                                _vm._l(_vm.submissionArray, function(
                                  submission,
                                  index
                                ) {
                                  return _c(
                                    "v-expansion-panel-content",
                                    { key: index },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "header" },
                                          slot: "header"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  submission.date
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(
                                            "\n                (" +
                                              _vm._s(submission.logs.length) +
                                              ")\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(submission.logs, function(log, i) {
                                        return _c(
                                          "div",
                                          { key: i },
                                          [
                                            _c(
                                              "v-container",
                                              {
                                                staticClass:
                                                  "px-4 py-3 submission-container",
                                                class: {
                                                  "not-last":
                                                    i !==
                                                    submission.logs.length - 1
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.showConfirmation(
                                                      log
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-layout",
                                                  {
                                                    class: {
                                                      "xs-font": _vm.isMobile,
                                                      "sm-up-font": !_vm.isMobile
                                                    },
                                                    attrs: { row: "", wrap: "" }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        class: {
                                                          "pb-0": _vm.isMobile
                                                        },
                                                        staticStyle: {
                                                          display: "grid"
                                                        },
                                                        attrs: {
                                                          xs12: "",
                                                          sm6: "",
                                                          md4: ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "primary--text"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    log.studentFirstName
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    log.studentLastName
                                                                  ) +
                                                                  "\n                          (" +
                                                                  _vm._s(
                                                                    log.studentExtId
                                                                  ) +
                                                                  ")\n                        "
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              log.studentSchoolName
                                                            ) +
                                                              " (" +
                                                              _vm._s(
                                                                log.grade
                                                              ) +
                                                              ")"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _vm.isAbsent(
                                                          log.absentType
                                                        )
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  color: "red",
                                                                  "font-weight":
                                                                    "bold"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          ABSENT\n                      "
                                                                )
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "militaryTimeToStandard"
                                                                    )(
                                                                      log.sessionTime
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                              log.sessionMinutes
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                          (" +
                                                                        _vm._s(
                                                                          log.sessionMinutes
                                                                        ) +
                                                                        " mins)\n                        "
                                                                    )
                                                                  ])
                                                                : _vm._e()
                                                            ]),
                                                        _vm._v(" "),
                                                        _c("div", [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                log.deliveryMode
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("div", [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                log.roomName
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("div", [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                log.notes
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        class: {
                                                          "pt-0": _vm.isMobile
                                                        },
                                                        attrs: {
                                                          xs12: "",
                                                          sm6: "",
                                                          md4: ""
                                                        }
                                                      },
                                                      [
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              log.planTypeName +
                                                                ": " +
                                                                log.serviceType
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("div", [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatDate"
                                                                )(
                                                                  log.serviceStartDate
                                                                )
                                                              ) +
                                                              " -\n                        " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatDate"
                                                                )(
                                                                  log.serviceEndDate
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("div", [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                log.providerFirstName +
                                                                  " " +
                                                                  log.providerLastName
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                          log.providerCredential
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "\n                          / " +
                                                                    _vm._s(
                                                                      log.providerCredential
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ])
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          log.supervisorFlag
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        size:
                                                                          "small",
                                                                        color:
                                                                          "green"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-checkbox-marked-circle\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        attrs: {
                                                          xs12: "",
                                                          md4: ""
                                                        }
                                                      },
                                                      [
                                                        _c("action-icons", {
                                                          attrs: {
                                                            fromDashboard: true,
                                                            submission: log
                                                          },
                                                          on: {
                                                            "service-log:deleted":
                                                              _vm.loadDashboard
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmationDialog
        ? _c(
            "div",
            [
              _c("submission-history", {
                attrs: {
                  submission: _vm.confirmationDialog,
                  fromDashboard: true
                },
                on: {
                  "reload:page": _vm.loadDashboard,
                  "dialog:closed": _vm.historyDialogClosed
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("bottom-nav"),
      _vm._v(" "),
      _vm.showLoading ? _c("full-screen-loading-spinner") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19c9d02c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c9d02c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard.vue
// module id = null
// module chunks = 